import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useMemo} from 'react'
import {useFragment} from 'react-relay'
import {PALETTE} from '../styles/paletteV3'
import defaultUserAvatar from '../styles/theme/images/avatar-user.svg'
import getShuffledArr from '../utils/getShuffledArr'

import Avatar from './Avatar/Avatar'
import ErrorBoundary from './ErrorBoundary'

const Container = styled('div')(({count}) => ({
  width: 44,
  display: 'flex',
  justifyContent: count > 1 ? 'flex-start' : 'center',
  flexWrap: 'wrap',
  bottom: count > 2 ? 4 : 0,
  position: 'relative'
}))

const AvatarWrapper = styled('div')(({count}) => ({
  width: count > 1 ? 20 : 'auto',
  height: count > 2 ? 20 : 'auto'
}))

const StyledAvatar = styled(Avatar)({
  border: `2px solid ${PALETTE.SLATE_200}`
})





const NewMeetingTeamPickerAvatars = (props) => {
  const {teamRef} = props

  const team = useFragment(
    graphql`
      fragment NewMeetingTeamPickerAvatars_team on Team {
        teamMembers {
          id
          picture
          isLead
          isSelf
        }
      }
    `,
    teamRef
  )

  const {teamMembers} = team

  const randomAvatars = useMemo(() => {
    const randomTeamMembers = getShuffledArr(teamMembers)

    const filteredMembers = [] 
    randomTeamMembers.forEach((member) => {
      // Always show the lead first
      if (member.isLead) {
        filteredMembers.unshift(member)
      } else if (teamMembers.length <= 4 || !member.isSelf) {
        filteredMembers.push(member)
      }
    })

    return filteredMembers.slice(0, 4)
  }, [teamMembers])

  return (
    React.createElement(Container, { count: randomAvatars.length,}
      , randomAvatars.map((teamMember) => {
        const {picture} = teamMember
        return (
          React.createElement(ErrorBoundary, { key: `pickerAvatar${teamMember.id}`,}
            , React.createElement(AvatarWrapper, { count: randomAvatars.length,}
              , React.createElement(StyledAvatar, { ...teamMember, picture: picture || defaultUserAvatar, size: 28,} )
            )
          )
        )
      })
    )
  )
}

export default NewMeetingTeamPickerAvatars
